module.exports = __webpack_public_path__ + "img/supplier-002.0bb81471.png";